import React from 'react'

import config from '../config.js'

import { MuiThemeProvider } from '@material-ui/core/styles'

import axios from 'axios'

import SystemMessageSnackbar from './SystemMessageSnackbar'

class Feed extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      systemMessage: {}
    }
  }

  componentDidMount() {}

  render() {
    const { systemMessage } = this.state

    return (
      <MuiThemeProvider theme={config.theme}>
        <ul className="friends-feed">
          <li className="recipe--shared">
            <img src="/assets/img/recipe-asparagus.jpg" alt="" />
            <span class="shared">
              Shared by <span className="shared-by">Kathy</span>
            </span>
          </li>
          <li className="recipe--made">
            <img src="/assets/img/recipe-cauliflower.jpg" alt="" />
            <span class="shared">
              Shared by <span className="shared-by">Kathy</span>
            </span>
          </li>
          <li className="post">
            Cooking is a love/hate relationship. Creating tasty foods and
            feeding people is so wonderful, but there are parts of the process
            that are just yucky. Like dishes and chopping...
            <span class="shared">
              Posted by <span className="shared-by">Kathy</span>
            </span>
          </li>
          <li className="recipe--shared">
            <img src="/assets/img/recipe-chocolate-cupcake.jpg" alt="" />
            <span class="shared">
              Shared by <span className="shared-by">Kathy</span>
            </span>
          </li>
          <li className="recipe--shared">
            <img src="/assets/img/recipe-cinnamon-bread.jpg" alt="" />
          </li>
          <li className="recipe--made">
            <img src="/assets/img/recipe-ham-raisin-sauce.jpg" alt="" />
          </li>
          <li className="recipe--shared">
            <img src="/assets/img/recipe-lemon-blueberry-cake.jpg" alt="" />
          </li>
          <li className="post">
            <span class="shared">
              Posted by <span className="shared-by">Kathy</span>
            </span>
          </li>
        </ul>
        <SystemMessageSnackbar systemMessage={systemMessage} />
      </MuiThemeProvider>
    )
  }
}

export default Feed



// WEBPACK FOOTER //
// ./src/Components/Feed.js